'use client';
import { Menu } from 'lucide-react';
import { SidebarTrigger } from '../../../components/sidebar';

export const SidebarMobileTrigger = ({}) => {
  return (
    <SidebarTrigger
      icon={Menu}
      className='h-10 w-10 lg:hidden [&_svg]:size-6'
    />
  );
};
